module.exports = __webpack_public_path__ + "static/img/smartControl2.cec81375.png";